import { Reference, Property, Name, Output } from '@components/Reference';
import Sandbox from '@components/Sandbox';
import { Spacer, Container, Row, Col } from '@cleartrip/bento/lib';
import * as React from 'react';
export default {
  Reference,
  Property,
  Name,
  Output,
  Sandbox,
  Spacer,
  Container,
  Row,
  Col,
  React
};